"use client";

import React, { createContext, useContext, useState } from "react";

const ConvertContext = createContext();

export function useConvertContext() {
  return useContext(ConvertContext);
}

export function ConvertProvider({ children }) {
  const [toSelected, setToSelected] = useState(null);
  // You can add more shared state here if needed

  return (
    <ConvertContext.Provider value={{ toSelected, setToSelected }}>
      {children}
    </ConvertContext.Provider>
  );
}
